import Badge from './Badge';
import SoldOutBadge from './SoldOutBadge/SoldOutBadge';

export { SoldOutBadge };
export default Badge;
